export const phoneMask = (phoneNumber) => {
  let numb = '';
  if (phoneNumber.length > 10) {
    numb = phoneNumber.replace(/\D/g, '').match(/(\d{2})(\d{5})(\d{4})/);
  } else {
    numb = phoneNumber.replace(/\D/g, '').match(/(\d{2})(\d{4})(\d{4})/);
  }
  return '(' + numb[1] + ') ' + numb[2] + '-' + numb[3];
};
